module.exports = __webpack_public_path__ + "fonts/nanumbarungothiclight-webfont.5e27e716.woff";